export function GetDateString(date) {
    return date.toLocaleDateString(undefined, {
        weekday: "long",
        year: "numeric",
        month: "long",
        day: "numeric",
    });
}
// A site is active/online once it's marked active and, if it has an expected online date, that
// date has passed.
export function isSiteActive(site, now) {
    if (now === void 0) { now = new Date(); }
    return (site.active &&
        (!site.expectedDateOnline || new Date(site.expectedDateOnline) <= now));
}
// Renders a Date for a `datetime-local` input, which wants wall-clock time in
// the viewer's zone with no offset suffix. Does not mutate its argument — the
// older inline copy of this helper in GlobalOrgBannerManagement does, which is a
// trap when the caller reuses the Date afterwards; it can converge here.
export function dateToInputString(date) {
    var local = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
    return local.toISOString().slice(0, 16);
}
